<script setup>
import { computed, onBeforeUpdate, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import Breadcrumbs from "../Breadcrumbs.vue";
import Swal from "sweetalert2";
import { useRouter } from "vue-router";

const store = useStore();
const isRTL = computed(() => store.state.isRTL);
const isNavFixed = computed(() => store.state.isNavFixed);
const darkMode = computed(() => store.state.darkMode);

const router = useRouter();
const route = useRoute();

const currentRouteName = computed(() => {
  return route.name;
});

const username = computed(() => sessionStorage.getItem("usuarioNombre"));
const userRole = sessionStorage.getItem("usuarioRol");

const navbarMinimize = () => store.commit("navbarMinimize");

const toggleNavigationOnMobile = () => {
  if (window.innerWidth < 1200) {
    navbarMinimize();
  }
};

onBeforeUpdate(() => {
  toggleNavigationOnMobile();
});

const confirmLogout = () => {
  Swal.fire({
    icon: "question",
    title: "¿Cerrar sesión?",
    text: "¿Está seguro de que desea cerrar sesión?",
    showCancelButton: true,
    confirmButtonText: "Cerrar sesión",
    cancelButtonText: "Cancelar",
    customClass: {
      confirmButton: "btn bg-gradient-success",
      cancelButton: "btn btn-dark",
    },
    buttonsStyling: false,
  }).then((result) => {
    if (result.isConfirmed) {
      logout(); // Llama a la función de cierre de sesión si el usuario confirma
    }
  });
};

const logout = () => {
  // Eliminar el token de sessionStorage
  localStorage.removeItem("authToken");
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("usuarioNombre");
  sessionStorage.removeItem("usuarioRol"); // Remove the user role from sessionStorage
  sessionStorage.removeItem("provincia"); // Remove the provincia from sessionStorage
  sessionStorage.removeItem("canton"); // Remove the canton from sessionStorage
  sessionStorage.removeItem("distrito"); // Remove the distrito from sessionStorage

  // Redirigir al login
  router.push({ name: "Login" });
};

</script>
<template>
  <nav id="navbarBlur" :class="`${!isNavFixed
      ? 'navbar navbar-main navbar-expand-lg p-0 shadow-none px- bg-white position-sticky left-auto top-0 z-index-sticky'
      : `navbar navbar-main navbar-expand-lg px-0 shadow-none position-sticky left-auto top-2 z-index-sticky`
    } ${isRTL ? 'top-0 position-sticky z-index-sticky' : ''}`" v-bind="$attrs" data-scroll="true">
    <div class="px-4 container-fluid ">
      <div class="sidenav-toggler sidenav-toggler-inner d-xl-block" :class="isRTL ? 'me-3' : ''" >
        <a href="#" class="p-0 nav-link text-body" @click.prevent="navbarMinimize">
          <div class="sidenav-toggler-inner">
            <i class="sidenav-toggler-line" :class="isNavFixed && !darkMode ? ' opacity-8 bg-dark' : 'bg-dark'
              "></i>
            <i class="sidenav-toggler-line" :class="isNavFixed && !darkMode ? ' opacity-8 bg-dark' : 'bg-dark'
              "></i>
            <i class="sidenav-toggler-line" :class="isNavFixed && !darkMode ? ' opacity-8 bg-dark' : 'bg-dark'
              "></i>
          </div>
        </a>
      </div>

      <!--
      <breadcrumbs :current-page="currentRouteName" />-->

      <div id="navbar" class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4"
        :class="isRTL ? 'px-0' : 'me-sm-4'">
        <div class="pe-md-3 d-flex align-items-center" :class="isRTL ? 'me-md-auto' : 'ms-md-auto'">
        </div>

        <ul class="navbar-nav justify-content-end">
          <li class="nav-item nav-hover d-flex align-items-center">
            <router-link to="/configuracion/mi-perfil" class="px-0 nav-link font-weight-bold" :class="isNavFixed && !darkMode ? ' opacity-8 text-dark ' : 'text-white'
              ">
              <i class="fas fa-user text-dark" :class="isRTL ? 'ms-sm-2' : 'me-sm-1'"></i>
              <span class="d-sm-inline d-none text-dark">{{ username || "Usuario" }} | {{ userRole === "administrador" ?
                "Administrador"
                : userRole === "dueno" ? "Dueño"
                  : "Colaborador" }}
              </span>
            </router-link>
          </li>
          <li class="nav-item nav-hover d-flex align-items-center ms-5">
            <a href="#" class="px-0 nav-link font-weight-bold" :class="isNavFixed && !darkMode ? ' opacity-8 text-dark' : 'text-dark'
              " @click.prevent="confirmLogout">
              <i class="fa fa-sign-out-alt" :class="isRTL ? 'ms-sm-2' : 'me-sm-1'"></i>
              <span class="d-sm-inline d-none">Cerrar Sesión</span>
            </a>
          </li>


        </ul>
      </div>
    </div>
  </nav>
</template>

<style>
.z-index-sticky {
  z-index: 920 !important;
}

.navbar-main {
  border-bottom: 4px solid #2dce89;
}

.nav-hover:hover {
  scale: 1.03;
  }
</style>